import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import { ADD_MODAL as UCC_PAY_FORM_MODAL } from './constants'

const UCCPayFormModal = Loadable(() => import('./UCCPayForm'))

export const createUCCPayNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'pay',
  text: translateFn('mnu_ucc_pay'),
  identity: UCC_PAY_FORM_MODAL,
  permission: 'UCC_VIEW',
  component: UCCPayFormModal,
}))
